var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckboxTrue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0C21.0609 0 22.0783 0.421427 22.8284 1.17157C23.5786 1.92172 24 2.93913 24 4V20C24 21.0609 23.5786 22.0783 22.8284 22.8284C22.0783 23.5786 21.0609 24 20 24H4C2.93913 24 1.92172 23.5786 1.17157 22.8284C0.421427 22.0783 0 21.0609 0 20V4C0 2.93913 0.421427 1.92172 1.17157 1.17157C1.92172 0.421427 2.93913 0 4 0H20ZM17.96 6.62667L9.33333 15.2533L6.04 11.96C5.85043 11.7834 5.5997 11.6872 5.34064 11.6918C5.08157 11.6963 4.83439 11.8013 4.65117 11.9845C4.46795 12.1677 4.363 12.4149 4.35843 12.674C4.35386 12.933 4.45003 13.1838 4.62667 13.3733L8.62667 17.3733C8.81417 17.5606 9.06833 17.6658 9.33333 17.6658C9.59833 17.6658 9.8525 17.5606 10.04 17.3733L19.3733 8.04C19.55 7.85043 19.6461 7.59971 19.6416 7.34064C19.637 7.08157 19.532 6.83439 19.3488 6.65117C19.1656 6.46795 18.9184 6.363 18.6594 6.35843C18.4003 6.35386 18.1496 6.45003 17.96 6.62667Z",
    fill: "#C3F474"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxTrue);
export default __webpack_public_path__ + "static/media/checkbox-true.9e3105b3e351f6d0672214c61dc2448b.svg";
export { ForwardRef as ReactComponent };